import script from "./ElementColorMask.vue?vue&type=script&lang=ts&setup=true"
export * from "./ElementColorMask.vue?vue&type=script&lang=ts&setup=true"

import "./ElementColorMask.vue?vue&type=style&index=0&id=0ae0ff99&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0ae0ff99"]])

export default __exports__